
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"5.445","cy":"18.75","r":"2.25","fill":"none","stroke":"#000","stroke-width":"1.26","transform":"translate(-1.468 -4.008) scale(1.19084)"}}),_c('circle',{attrs:{"cx":"18.945","cy":"18.75","r":"2.25","fill":"none","stroke":"#000","stroke-width":"1.25","transform":"matrix(1.19963 0 0 1.20089 -4.237 -4.219)"}}),_c('path',{attrs:{"d":"M20.823 19.66c.823 0 1.043-.837 1.043-1.66v-4.447c0-.501-.251-.97-.668-1.248l-1.3-.868a1.496 1.496 0 01-.454-.476l-1.64-2.733a1.502 1.502 0 00-1.293-.728h-2.046c-.526 0-1.015.277-1.286.728l-3.01 5.011-5.767.113s-3.368-.078-3.382 2.596c-.007 1.228.802 1.82.802 1.82M7.567 19.5h8.254M7.789 5.058l12.045 8.435","fill":"none","stroke":"#000","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M7.744 2.407v4.434H.888M20.648 12h-9.573","fill":"none","stroke":"#000","stroke-width":"1.5","stroke-miterlimit":"1.5"}})])
          )
        }
      }
    